import script from "./ShopPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopPage.vue?vue&type=script&setup=true&lang=ts"

import "./ShopPage.vue?vue&type=style&index=0&id=587bab94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587bab94"]])

export default __exports__